import React from 'react';
import styles from './StartNetworkingGroup.module.scss';

function StartNetworkingGroup(props) {
    const {className, icon, iconClassName = '', name, description, visible = true, children} = props;

    if (!visible) return null;

    // TODO: hide group if it doesn't have visible children

    return (
        <div className={[styles.StartNetworkingGroup, className, 'content'].join(' ')}>
            <div className={[styles.icon, iconClassName].join(' ')} style={{backgroundImage: `url(${icon})`}} />
            <div className={styles.name}>{name}</div>
            <div className={styles.description}>{description}</div>
            <div className={styles.content}>{children}</div>
        </div>
    );
}

export default StartNetworkingGroup;
